// Mock data for North East Grove — luxury commercial leasing single-page site

export const BROCHURE_URL = "/assets/brochure.pdf";

export const nav = {
  brand: "North East Grove",
  links: [
    { label: "About", href: "#about" },
    { label: "Overview", href: "#overview" },
    { label: "Plans & Views", href: "#views" },
    { label: "Location", href: "#location" },
    { label: "Call us", href: "#contact" },
  ],
};

export const hero = {
  eyebrow: "Shankar Nagar · Nagpur",
  title: ["Built for visibility.", "Designed for versatility."],
  image: "/assets/hero-building.jpeg",
  paragraphs: [
    "North East Grove stands on a north east corner plot in **Shankar Nagar, Nagpur**.",
    "The building offers four levels (one tenant per level) of adaptable space that can be customised for offices, showrooms, or retail use. Its clear layout, strong visibility, and modern structure makes it a practical and prominent address for business.",
  ],
};

export const stats = [
  { value: 5900, display: "5,900", label: "Plot Size (sq ft)" },
  { value: 10400, display: "10,400", label: "Total built area (sq ft)" },
  { value: 4, display: "4", label: "Floors" },
  { value: 16, display: "16", label: "Car Space" },
];

export const views3d = {
  title: "3D Views",
  tabs: [
    { id: "building", label: "Building Views", image: "/assets/building-views.jpg" },
    { id: "entrance", label: "Entrance Views", image: "/assets/entrance-views.webp" },
    { id: "signage", label: "Signage", image: "/assets/signage.png" },
  ],
  note: "All plans and visuals are indicative and subject to refinement.",
};

export const overview = {
  title: "Building Overview",
  rows: [
    { label: "Plot size", values: ["~5,900 sq ft"] },
    {
      label: "Configuration",
      values: [
        "Ground Floor: ~2,000 sq ft",
        "1st to 3rd Floor: ~2,800 sq ft each",
        "Basement: Dedicated parking for 18 cars and 30 two-wheelers",
      ],
    },
    { label: "Ownership", values: ["Single owner"] },
    { label: "Status", values: ["Under finishing, ready for fit-out"] },
    {
      label: "Key Highlights",
      values: [
        "Vaastu compliant \u2013 Corner frontage on the north and east sides",
        "Additional open space on the ground floor",
        "Diesel Genset backup",
        "Provision for solar installation",
      ],
    },
  ],
};

export const carpetArea = {
  title: "Carpet Area Details",
  headers: ["Floor", "Usage", "Apprx Carpet Area sq.m", "Apprx Carpet Area sq.ft."],
  rows: [
    ["Ground Floor", "Retail", "183.280", "~1,973"],
    ["1st Floor", "Retail / Commercial", "259.365", "~2,792"],
    ["2nd Floor", "Office / Commercial", "259.365", "~2,792"],
    ["3rd Floor", "Office / Commercial", "259.365", "~2,792"],
  ],
};

export const elevation = {
  title: "Building Elevation",
  note: "All plans and visuals are indicative and subject to refinement.",
  image: "/assets/elevation.png",
};

export const floorPlans = {
  title: "Floor Plans",
  note: "All plans and visuals are indicative and subject to refinement.",
  images: ["/assets/layout-1.png", "/assets/layout-2.png"],
};

export const location = {
  title: ["At the centre of Shankar Nagar\u2019s", "retail and business district"],
  description:
    "North East Grove is located on a prime corner in Shankar Nagar, a well-known hub for retail and business in Nagpur. The neighbourhood is home to leading jewellers, banks, and lifestyle stores, creating a lively and well-connected commercial setting. With the metro station and main city roads close by, it offers easy access and steady footfall through the day.",
  neighbourhood: [
    { label: "Leading jewellers", value: "Batukbhai, Parekh Brothers, Dass, Karan Kothari" },
    { label: "Retail and lifestyle", value: "Lotus Electronics, Apple Showroom, Under Armour" },
    { label: "Banks", value: "AU Small Finance Bank, Kotak Mahindra Bank" },
    { label: "Landmarks", value: "Wockhardt Hospital, Centre Point Hotel" },
    { label: "Connectivity", value: "Metro Station, Ambazari Road, Sitabuldi Market, VNIT" },
  ],
  mapImage: "/assets/map.png",
};

export const contact = {
  banner: "Not for Sale \u2014 Leasing only!",
  intro: "For availability, lease discussions, or property-related queries, contact:",
  team: "Team Indusmen",
  phone: "+91 91123 88088",
  phoneHref: "tel:+919112388088",
  email: "assist@indusmen.com",
  emailHref: "mailto:assist@indusmen.com",
  address: ["66, Shankar Nagar,", "Nagpur,", "Maharashtra 440010"],
  copyright: "\u00A9 Copyright 2025 North East Grove. All Rights Reserved.",
};
